import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "getting-started-guide",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#getting-started-guide",
        "aria-label": "getting started guide permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Getting Started Guide`}</h1>
    <p>{`Welcome to `}<strong parentName="p">{`AstroPay`}</strong>{` - `}<strong parentName="p">{`WooCommerce`}</strong>{`!`}</p>
    <p>{`This app allows you to connect `}<strong parentName="p">{`AstroPay`}</strong>{` as a payment method in your `}<strong parentName="p">{`WooCommerce`}</strong>{` store. With the following documentation you will obtain the necessary information to install and configure `}<strong parentName="p">{`AstroPay`}</strong>{`.`}</p>
    <h2 {...{
      "id": "requirements",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#requirements",
        "aria-label": "requirements permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`In order to use `}<strong parentName="li">{`AstroPay`}</strong>{` as a means of payment, you must be registered as a partner of `}<strong parentName="li">{`AstroPay`}</strong>{`. If you're not already registered, contact a business advisor to sign you up and provide you with the necessary credentials to integrate with `}<strong parentName="li">{`WooCommerce`}</strong>{`.`}</li>
      <li parentName="ul">{`Additionally, for the correct functioning it will be necessary:`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`WordPress:`}</strong>{` version 5.4 or higher.`}</li>
          <li parentName="ul"><strong parentName="li">{`WooCommerce:`}</strong>{` version 4.3.2 or higher.`}</li>
          <li parentName="ul"><strong parentName="li">{`PHP:`}</strong>{` version 7.0 or higher.`}</li>
          <li parentName="ul">{`Plugin `}<a target="_blank" href="https://woocommerce.com/document/subscriptions/" style={{
              "color": "#f90103",
              "background": "url('/link-16.png') no-repeat 100% 0",
              "backgroundSize": "16px 16px",
              "paddingRight": "19px"
            }}><u>{`WooCommerce Subscriptions`}</u></a>{`.`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "plugin",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#plugin",
        "aria-label": "plugin permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Plugin`}</h2>
    <ul>
      <li parentName="ul">{`Latest stable version: `}<a href="/plugin/astropay-woocommerce_2.0.1.zip" style={{
          "color": "#f90103",
          "background": "url('/link-16.png') no-repeat 100% 0",
          "backgroundSize": "16px 16px",
          "paddingRight": "19px"
        }}><u>{`AstroPay - WooCommerce 2.0.1`}</u></a>{`.`}</li>
    </ul>
    <Link to="/installation-onboarding" style={{
      padding: "7.5px 15px",
      backgroundColor: "#f90103",
      color: "white",
      borderRadius: "5px"
    }} mdxType="Link">Get started now!</Link>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      